import axios from 'axios'
import { CommonPriorityResponse } from '@/api/services/common/priority/common-priority.dto'

class CommonPriorityService {
    async getPriorities(): Promise<CommonPriorityResponse[]> {
        const response = await axios.get<CommonPriorityResponse[]>(`/priorities`)
        return response.data
    }
}

export const commonPriorityService = new CommonPriorityService()
